import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00931a1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "headers"
}
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<a class=\"logopb\" href=\"https://www.policybazaar.com\" data-v-00931a1e></a><a class=\"pnb\" href=\"javascript:void(0)\" data-v-00931a1e><img src=\"https://static.pbcdn.in/term-cdn/images/vue/PNB_Metlife_logo_mob.png\" data-v-00931a1e></a><a class=\"bazaz\" href=\"javascript:void(0)\" data-v-00931a1e><img src=\"https://static.pbcdn.in/term-cdn/images/vue/bazazlogo.png\" data-v-00931a1e></a>", 3)
const _hoisted_6 = [
  _hoisted_3
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-00931a1e><a class=\"pblogos\" data-v-00931a1e><img alt=\"policy bazaar\" src=\"https://static.pbcdn.in/term-cdn/images/vue/logo.png\" data-v-00931a1e></a><a class=\"pnb\" href=\"javascript:void(0)\" data-v-00931a1e><img src=\"https://static.pbcdn.in/term-cdn/images/vue/PNB_Metlife_logo_mob.png\" data-v-00931a1e></a><a class=\"bazaz\" href=\"javascript:void(0)\" data-v-00931a1e><img src=\"https://static.pbcdn.in/term-cdn/images/vue/bazazlogo.png\" data-v-00931a1e></a></div>", 1)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://static.pbcdn.in/term-cdn/images/vue/Phone.png" }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Talk to "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("an Expert")
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isMobiledevice())
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["containers", {'bazazHead':_ctx.isBajajMarketingId}])
          }, [
            (!_ctx.isMobiledevice())
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(["header-mobs", {'bazazHead':_ctx.isBajajMarketingId}])
        }, [
          _hoisted_7,
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openTalktoExpert && _ctx.openTalktoExpert(...args))),
            class: "quotetop-rights"
          }, _hoisted_9)
        ], 2))
  ]))
}